/**
 * useProject - Hook personnalisé pour récupérer les données d'un projet à partir de son slug.
 */
import { useState, useEffect, useCallback, useRef } from 'react';
import { getProject } from '../api';

export default function useProject(slug) {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  const fetchProject = useCallback(() => {
    if (!slug) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    getProject(slug)
      .then((data) => { if (mountedRef.current) setProject(data); })
      .catch((err) => {
        if (mountedRef.current) {
          setError(err.response?.data?.detail || err.message || 'Erreur lors du chargement du projet');
        }
      })
      .finally(() => { if (mountedRef.current) setLoading(false); });
  }, [slug]);

  useEffect(() => {
    fetchProject();
  }, [fetchProject]);

  const refreshProject = useCallback(() => {
    if (!slug) return Promise.resolve(null);
    return getProject(slug)
      .then((data) => {
        if (mountedRef.current) setProject(data);
        return data;
      })
      .catch((err) => {
        console.warn('Erreur lors du rafraîchissement du projet:', err);
        return null;
      });
  }, [slug]);

  return { project, loading, error, refreshProject };
}
